import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rightArrow",
  "use": "icon-rightArrow-usage",
  "viewBox": "0 0 45 45",
  "content": "<symbol viewBox=\"0 0 45 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rightArrow\">\r\n<path d=\"M16.5254 33.0527L27.5429 22.0351L16.5254 11.0176\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol